import * as React from "react";
import { useMemo } from "react";
import { PluginStore } from "graylog-web-plugin/plugin";
export default () => {
  const [Component] = useMemo(
    () => {
      var _a;
      return (_a = PluginStore.exports("pages").map((c) => {
        var _a2;
        return (_a2 = c.search) == null ? void 0 : _a2.component;
      }).filter((c) => !!c)) != null ? _a : [];
    },
    []
  );
  return /* @__PURE__ */ React.createElement(Component, null);
};
